import { Component } from '@angular/core';
import { NewEntryService } from '../../services/new-entry.service';
import { NewEntryModel } from '../../models/new-entry.model';
import { paramsForServer } from 'feathers-hooks-common';
import { EntryUtilityService } from '../../services/entry-utility.service';



@Component({
  templateUrl: './util-page.html',
  styleUrls: ['./util-page.scss'],
})

export class UtilPageComponent {

  output:any = '';


  constructor(
    private newEntryService:NewEntryService,
    private entryUtilityService:EntryUtilityService,
  ) {
  }


  ngOnInit() {


  }


  private outputEntries(numEntries) {


    this.newEntryService.find({
      query: {
        $limit: numEntries,
      },
    })
      .then(result => {

        console.log('result', result);
        this.output = result.data.map(entry => entry.rendering + '<br>').join('');

      });


  }


  async generateRenderings(numEntries) {

    const result = await this.newEntryService.find({
      query: {
        $limit: numEntries,
      },
    });

    const entries = result.data;
    await this.generateRenderingForEntries(entries);
  }

  async generateRenderingsForLetter(letterNum:number) {

    const result = await this.newEntryService.find({
      query: {
        // $limit: 50,
        letter: letterNum,
      },
    });

    const entries = result.data;
    await this.generateRenderingForEntries(entries);
  }

  async generateRenderingsForAllLetters() {
    for (let i=22; i <= 22; i++) {
      this.output = 'Letter: ' + i;
      await this.generateRenderingsForLetter(i);
    }
  }

  async generateOrderForAllLetters() {
    for (let i=2; i <= 22; i++) {
      this.output = 'Letter: ' + i;
      await this.generateOrderForLetter(i);
    }
  }

  private async generateRenderingForEntries(entries) {
    let i = 0;
    for (let entry of entries) {

      await this.newEntryService.patch(entry._id, {
        dummy: entry.dummy,
      });

      i++;
      if (i % 100 == 0) {
        this.output = i;
      }
    }

    this.output = `Done (${entries.length})`;
  }

  async generateOrderForLetter(letterNum:number) {

    this.output = '';

    Promise.resolve()
      .then(() => this.entryUtilityService.create({
        command: 'reorder',
        params: {
          letter: letterNum,
        },
      }))
      .then(result => {
        this.output = `Done (${result.numEntries})`;
      });


  }
}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/util-page/util-page.ts